module.exports = __webpack_public_path__ + "static/img/2.014db34.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/eng/2.png
// module id = qCbz
// module chunks = 0